const clickoutPopupEventsHandler = {
    data: {
        popupClickoutObserver: null,
        clickoutPopupMakeModel: '',
        clickoutPopupPageName: '',
    },
    beforeDestroy() {
        this.unbindPopupClickoutTracking();
    },
    methods: {
        bindPopupClickoutTracking(pageName, makeModel) {
            this.clickoutPopupPageName = pageName;
            this.clickoutPopupMakeModel = makeModel;

            // Watch for and track the click on the popup CTA
            // Binds to document click because the
            // popup from PopupMaker may not be present
            // in the DOM at the moment of the `mounted()`
            document.addEventListener('click', this.handlePopupClickoutClick);

            // Watch for and track the opening of the popup
            try {
                // Watch only within the `.popmake` container
                const container = document.querySelector('.shortcode-clickout').closest('.popmake');

                if (!container) {
                    return;
                }

                if (container.style.display === 'block') {
                    // Handle the case in which the popup is already
                    // visible when the current script loads and runs
                    this.triggerPopupDisplayedEvent();
                } else {
                    // Watch for the moment in which the clickout popup
                    // becomes visible using the MutationObserver
                    this.popupClickoutObserver = new MutationObserver((mutations) => {
                        // Find the mutation by which the `display` becomes `block`
                        const displayMutation = mutations.find(
                            (m) => m.target.style.display && m.target.style.display === 'block'
                        );

                        if (displayMutation) {
                            // If the mutation has been found,
                            // disconnect the observer to not
                            // trigger duplicate events.
                            this.popupClickoutObserver.disconnect();

                            this.triggerPopupDisplayedEvent();
                        }
                    });

                    this.popupClickoutObserver.observe(container, {
                        attributes: true,
                    });
                }
            } catch {
                // Silently fail if MutationObserver is not supported
            }
        },
        handlePopupClickoutClick(event) {
            const popupLink = event.target.closest('.popmake .shortcode-clickout__link');
            if (popupLink) {
                const redirectURL = popupLink.href;

                // Only push the GA event in the case in which
                // the click was executed on the popup clickout link
                this.pushGtagEvent('clickout_popup_click', null, null, {
                    page: this.clickoutPopupPageName,
                    // eslint-disable-next-line camelcase
                    make_model: this.clickoutPopupMakeModel,
                    // eslint-disable-next-line camelcase
                    current_page: window.location.href,
                    // eslint-disable-next-line camelcase
                    redirect_to: redirectURL,
                });
            }
        },
        triggerPopupDisplayedEvent() {
            this.pushGtagEvent('clickout_popup_open', null, null, {
                page: this.clickoutPopupPageName,
                // eslint-disable-next-line camelcase
                make_model: this.clickoutPopupMakeModel,
                // eslint-disable-next-line camelcase
                current_page: window.location.href,
            });
        },
        unbindPopupClickoutTracking() {
            document.removeEventListener('click', this.handlePopupClickoutClick);
            if (this.popupClickoutObserver) {
                this.popupClickoutObserver.disconnect();
            }
        },
    },
};

export default clickoutPopupEventsHandler;
